import { render, staticRenderFns } from "./care.vue?vue&type=template&id=1556abad&"
import script from "./care.vue?vue&type=script&lang=js&"
export * from "./care.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports